import React from 'react';
import { connect, useSelector } from 'react-redux';

import {
  Card,
  CardActionArea,
  Typography,
  Chip,
  Box,
} from '@mui/material';
import {
  fetchLinkedTargets,
  fetchLinkedTarget,
  fetchLinkedFlows,
  fetchSupportedFlows,
  fetchJob,
} from '../../redux/actions';
import { getSelectedFlow, isJobPending } from '../../redux/selectors';
import * as UIAction from '../../redux/actions/ui.actions';
import * as TargetCardUtil from './TargetCardUtil';
import { getLogoUrl } from '@hotglue/common';

const TargetCard = ({
  target,
  flowId,
  fetchJob,
  tenantId
}) => {
  const lastJob = useSelector((state) => state.jobs.lastJob[`${tenantId}/${flowId}/${target.target}`]);
  const pendingJob = useSelector((state) => isJobPending(state, lastJob?.s3_root, flowId, tenantId));
  React.useEffect(() => {
    if (!lastJob || lastJob.flow_id !== flowId) {
      // If there is no last job, check if there is one
      fetchJob(target.target, 'target');
    }
  }, [lastJob]);

  React.useEffect(() => {
    if (
      !pendingJob &&
      lastJob &&
      lastJob.status &&
      !(lastJob.status.includes('FAILED') || lastJob.status.includes('COMPLETE'))
    ) {
      console.log(`Polling job ${lastJob.job_id}`);
      TargetCardUtil.pollJob(lastJob.s3_root, flowId, tenantId, target.target);
    }
  }, [lastJob]);

  const { label, version } = target;
  const icon = getLogoUrl(target);

  const onClickBody = () => {
    UIAction.goToEntityConfig(target, 'target');
  };

  return (
    <Card
      elevation={0}
      sx={{
        border: ({ palette }) => `1px solid ${palette.common.outline}`,
        height: '160px',
        cursor: 'pointer',
      }}
    >
      <CardActionArea
        id="LinkedSourceCard"
        onClick={onClickBody}
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          height: '100%',
          position: 'relative',
        }}
      >
        <Box top={0} right={0} left={0} position="absolute" height={'32px'}>
          <Box
            height={'32px'}
            width="100%"
            sx={{ position: 'relative', display: 'flex', justifyContent: 'flex-end', alignItems: 'flex-end' }}
          >
            <Box display="flex" role='tooltip' aria-label='linked tooltip' bgcolor="success.light" borderRadius="10px" mr={1}>
              <Typography variant="body2" fontSize="8px" color="success.dark" sx={{ px: 1, py: '2px' }}>
                LINKED
              </Typography>
            </Box>
          </Box>
        </Box>
        <Box display="flex" flexDirection="column" gap={2} alignItems="center">
          <Box component="img" role={'img'} alt={`image for ${label} target`} width="48px" height="48px" src={icon} sx={{ objectFit: 'contain' }} />
          <Typography variant="h2">{label}</Typography>
        </Box>
        {version && (
        <Box
          sx={{
            position: 'absolute',
            bottom: 10,
            right: 10,
          }}
        >
          <Chip
            role='tooltip'
            aria-label='target version'
            label={version}
            size="small"
            sx={{ color: '#676767', fontSize: '10px', height: '18px', fontWeight: '300' }}
          />
        </Box>
        )}
      </CardActionArea>
    </Card>
  );
};

const mapStateToProps = (state, props) => {
  const flowId = getSelectedFlow();

  return {
    lastJob: state.jobs.lastJob[flowId],
    flowId,
    tenantId: state.configuration.tenant_id,
    jobsEnabled: state.preferences.jobsEnabled,
    writeJobsEnabled: state.preferences.writeJobsEnabled,
    demo: state.configuration.demo || state.preferences.demoMode,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchLinkedTarget: (target) => dispatch(fetchLinkedTarget(target)),
    fetchLinkedTargets: () => dispatch(fetchLinkedTargets()),
    fetchLinkedFlows: () => dispatch(fetchLinkedFlows()),
    fetchSupportedFlows: () => dispatch(fetchSupportedFlows()),
    fetchJob: (entityId, entityType) => dispatch(fetchJob(undefined, undefined, entityId, entityType)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TargetCard);
